export default "__VITE_ASSET__DX1SU4a6__";